import { isNotEmptyObject } from './isNotEmptyObject';

export function buildGroups(groups: any): any {
	if (isNotEmptyObject(groups)) {
		return { groups: groups };
	}
	return undefined;
}
